import Docs from '@axten/docs'
import { Vue } from 'nuxt-property-decorator'

Vue.component('Docs', Docs)

export default ({ app }, inject) => {}
